import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pr-2" }
const _hoisted_2 = { class: "flex justify-between text-sm text-secondary" }

import 'vue-slider-component/theme/antd.css';

import { computed, ref, watch } from 'vue';
import VueSlider from 'vue-slider-component';

import { theme } from '@/../tailwind.config';
import useDarkMode from '@/composables/useDarkMode';

interface Props {
  modelValue: string | number;
  leftLabel: string;
  rightLabel: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: '0' },
    leftLabel: { default: '' },
    rightLabel: { default: '' }
  },
  emits: ['change', 'update:modelValue', 'dragEnd'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: string | number, leftLabel: string, rightLabel: string }




const range = ref(0);
const { darkMode } = useDarkMode();

const colors = theme.extend.colors;

function onChange(value) {
  emit('change', value);
  emit('update:modelValue', value);
}

function onDragEnd() {
  emit('dragEnd', props.modelValue);
}

const dotStyle = computed(() => {
  return {
    backgroundColor: colors.blue['500'],
    borderColor: colors.blue['500'],
    borderWidth: 0,
    backgroundImage: `linear-gradient(to top right, ${colors.blue['500']}, ${colors.pink['500']})`,
  };
});

const railSyle = computed(() => {
  return {
    background: darkMode.value ? colors.gray['900'] : colors.gray['100'],
  };
});

const proccessStyle = computed(() => {
  return {
    backgroundImage: `linear-gradient(to top right, ${colors.blue['500']}, ${colors.pink['500']})`,
  };
});

watch(
  () => props.modelValue,
  newVal => {
    range.value = Number(newVal) || 0;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (_ctx.$slots.leftLabel || __props.leftLabel)
          ? _renderSlot(_ctx.$slots, "leftLabel", { key: 0 }, () => [
              _createTextVNode(_toDisplayString(__props.leftLabel), 1)
            ])
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (_ctx.$slots.rightLabel || __props.rightLabel)
          ? _renderSlot(_ctx.$slots, "rightLabel", { key: 0 }, () => [
              _createTextVNode(_toDisplayString(__props.rightLabel), 1)
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(VueSlider), _mergeProps({
      modelValue: range.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event))
    }, _ctx.$attrs, {
      dotStyle: _unref(dotStyle),
      railStyle: _unref(railSyle),
      processStyle: _unref(proccessStyle),
      onChange: onChange,
      onDragEnd: onDragEnd
    }), null, 16, ["modelValue", "dotStyle", "railStyle", "processStyle"])
  ]))
}
}

})